<template>
  <div class="batch-move-overload">
    <div class="batch-move-overload-content">
      <div class="batch-move-overload-title">
        Sistema em sobrecarga
      </div>

      <div class="batch-move-overload-description">
        Não foi possível concluir o loteamento agora.
        Tente novamente em alguns instantes.
      </div>

      <div
        v-if="retryAfter"
        class="batch-move-overload-retry-after"
      >
        Sugestão: aguarde aproximadamente {{ retryAfter }} segundos.
      </div>
    </div>

    <footer class="batch-move-overload-footer">
      <md-button
        class="btn btn-nonenary"
        @click="handleClose"
      >
        Fechar
      </md-button>

      <md-button
        class="btn btn-primary"
        @click="handleRetry"
      >
        Tentar novamente
      </md-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BatchMoveOverloadView',
  props: {
    retryAfter: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleRetry() {
      this.$emit('retry')
    },
  },
}
</script>

<style lang="scss" scoped>
.batch-move-overload {
  font-family: 'Exo 2', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  &-content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &-title {
    font-weight: 700;
    font-size: 1.125rem;
  }

  &-description {
    font-weight: 400;
    font-size: 1rem;
    color: #666666;
  }

  &-retry-after {
    font-size: 0.875rem;
    color: #ef6c00;
  }

  &-footer {
    display: flex;
    gap: 1rem;

    .md-button {
      flex: 1;
    }
  }
}
</style>
